export const MAX_FLOATING_HELPER_PROMOTION_DAYS = 3
